var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYardiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.73 69.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072ce;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Yardi_Blue",
    "data-name": "Yardi | Blue",
    className: "cls-1",
    d: "M0,69.87V41L50.22,0V29.69ZM9.08,32.93,0,27.85V0L9.08,5.34Zm69.09.52L66.29,1.57h13.8l6.12,21.31L100.53,1.57H116.6l-25.24,32L87.28,52.84H74.07ZM128.56,1.57H142.1l8.39,51.27H137.05l-1.22-9.17H117.76l-5.17,9.17H98.52Zm-5.67,32.14h11.79l-2-18.43h-.09ZM164.28,1.57h25.16q8,0,11.79,2.54,4.71,3.14,4.72,10.74,0,12.66-11.71,14.32v.09q5.25,1.3,5.24,8.56c0,1.34,0,3-.13,5.11s-.13,3.56-.13,4.5c0,2.67.26,4.48.79,5.41H186.56a15,15,0,0,1-.44-2.88c0-.82.06-2.2.17-4.15s.18-3.54.18-4.76q0-6.9-6.65-6.9H170.9L167,52.84H153.63ZM173,24.28h10.64q9,0,9-7.07,0-5.34-7.22-5.33h-9.84ZM217,1.57h19.2q22.87,0,22.88,21.66,0,12.75-7.33,20.79-8.13,8.82-22.7,8.82h-23Zm5,39.83h8.82q7.77,0,11.79-6a19.32,19.32,0,0,0,3.14-11Q245.68,13,235.55,13h-7.68ZM271.34,1.57h13.39L274.07,52.84H260.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYardiLogo);
export default __webpack_public_path__ + "static/media/yardi_logo.cc7f697005f1043250ff01ade0a76f6e.svg";
export { ForwardRef as ReactComponent };